const TeamPostRequest = (() => {
    const DOM = {};
    let allTeamCategories;
    let remainingTeamCategories;
    let observerTarget;

    const cacheDOM = () => {
        DOM.parentSection = document.getElementsByClassName("team__container")[0];
        DOM.loadMore = document.getElementsByClassName("js-team-load-more")[0];
    };

    /**
     * Reutrns next category from the available category list
     * @param remainingCategoriesList
     * @returns {String[]}
     */
    const getNextCategory = (remainingCategoriesList) => {
        if ( remainingCategoriesList === null && remainingCategoriesList === undefined ) return;
        return remainingCategoriesList[0];
    };

    /**
     * Remove current category from the avialble category list
     * @param category
     */
    const removeCategory = (category) => {
        if ( category === null && category === undefined ) return;

        const allCategoriesList = ( remainingTeamCategories !== null && remainingTeamCategories !== undefined ) ? remainingTeamCategories : allTeamCategories;

        remainingTeamCategories = allCategoriesList.filter(availableCategory => availableCategory.id !== category);
    };


    /**
     * Checks if given category is set in the available category list
     * @param category
     * @returns {String[]}
     */
    const checkCurrentCategory = (category) => {
        if ( category === null && category === undefined ) return;
        return Object.values(allTeamCategories).find(value => value.id === category);
    };

    /**
     * Remove Load More button from the DOM if categories list is empty
     */
     const removeLoadeMoreButton = () => {
        if ( remainingTeamCategories.length !== 0 ) return;
        DOM.parentSection.classList.add('team__container--spacing-bottom');
        DOM.loadMore.remove();
        lazyLoadObserver.unobserve(observerTarget);
    }

    /**
     * Remove loader from the DOM
     */
    const removeLoader = () => {
        setTimeout(() => {
            if ( document.getElementsByClassName("loading")[0] ) document.getElementsByClassName("loading")[0].remove();
            DOM.loadMore.innerHTML = `Load More`;
            DOM.parentSection.classList.remove('js-loading');
        },500);
    }
  
    /**
     * Generates markup of the posts related to the selected category
     * @param postData
     */
    const updatePosts = (postData) => {
        let content = '';
        const postTitle = postData.title;
        const postThumbnail = postData.thumbnail;
        const postThumbnailAlt = postData.thumbnail_alt;
        const postJobTitle = postData.job_title ?
                            `<span>${postData.job_title}</span>`
                            : false;
        const postContactDetails = postData.contact_details;
        const postSocialDetails = postData.social_details;

        let contactDetails = '';
        if ( postContactDetails ) {
            contactDetails += `<ul>`;
            Array.from(postContactDetails).forEach( contact => {
                const telephone_label = contact.telephone_label
                                        ? `<span>${contact.telephone_label} :</span>`
                                        : '';
                const telephone_number = contact.telephone_number ?? '';
                const telephone_add_extension = contact.telephone_add_extension ?? '';
                const telephone_extension = contact.telephone_extension ?? '';
                const telephone_ext_text = telephone_add_extension
                                        ? `<span>Ext : ${telephone_extension}</span>`
                                        : '';

                contactDetails += `<li>
                                    ${telephone_label}
                                    <a href="tel:${telephone_number}" class="team__item__email button-arrow">
                                        ${telephone_number}
                                    </a>
                                    ${telephone_ext_text}
                                </li>`;
            })
            contactDetails += `</ul>`;
        }

        let socialDetails = '';
        if ( postSocialDetails ) {
            socialDetails += `<div class="team__item__contacts team__item__contacts--column">
                            <ul class="team__item__social">`;
            Array.from(postSocialDetails).forEach( social => {
                const social_label = social.social_label ?? '';
                const social_url = social.social_url ?? '';

                socialDetails += `<li class="${social_label}">
                                    <a href="${social_url}"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        title="${social_label}">
                                        <span class="sr-only">${social_label}</span>
                                    </a>
                                </li>`;
            })
            socialDetails += `</ul>
                            </div>`;
                            
        }

        content = `<div class="team__item">
                        <div class="team__item__image">
                            <img src="${postThumbnail}" alt="${postThumbnailAlt}">
                        </div>
                        <div class="team__item__inner">
                            <div class="team__item__details">
                                <h3>
                                    ${postTitle}
                                </h3>
                                ${postJobTitle}
                                ${contactDetails}
                            </div>
                            ${socialDetails}
                        </div>
                    </div>`;

        return content;
    }

    /**
     * Inserts generated of the posts markup to the DOM
     * @param postsData
     */
    const loadCategoryPosts = (postsData) => {
        const categoryDescription = postsData.categoryDescription ?
                            `<p>${postsData.categoryDescription}</p>`
                            : '';
        let content = `<div class="team__heading">
                            <h2>${postsData.categoryTitle}</h2>
                            ${categoryDescription}
                        </div>
                        <div class="team__list">`;

                        postsData.postDetails.forEach((post) => {
                            content += updatePosts(post);
                        });
        
            content += `</div>`;

        DOM.loadMore.insertAdjacentHTML('beforebegin', content);

        removeLoadeMoreButton();
        if ( document.getElementsByClassName("js-team-load-more")[0] ) {
            lazyLoadObserver.observe(document.getElementsByClassName("js-team-load-more")[0]);
        }
        removeLoader();
    }

    /**
     * Returns posts of the selected category
     * @param postType
     * @param postID
     */
     const getCategoryPosts = (postType, postID) => {
        const categoryPostsDataURL =
            `${document.location.origin}/wp-json/v2/taxonomy?post_type=${postType}&taxonomy_id=${postID}`;

        const loader = `<div class="loading"><div></div><div></div><div></div><div></div></div>`;
        DOM.loadMore.innerHTML = loader;
        DOM.parentSection.classList.add('js-loading');

        const postsRequest = new XMLHttpRequest();
        postsRequest.open("GET", categoryPostsDataURL);
        postsRequest.send();
        postsRequest.onload = () => {
            if (postsRequest.status === 200) {
                const postsData = JSON.parse(postsRequest.response);
                removeCategory(postID);
                loadCategoryPosts(postsData);
            }
        };
     }

    /**
     * Returns info of the next category from the categories list
     * @param postType
     * @param postID
     */
     const getNextCategoryDetails = (postType, postID) => {
        const currentCategory = checkCurrentCategory(postID);
        removeCategory(currentCategory.id);
        const nextCategoryID = getNextCategory(remainingTeamCategories);
        getCategoryPosts(postType, nextCategoryID.id);
     }

    /**
     * Returns all categories from the custom endpoint
     * @param el
     */
    const getCurrentCategoryDetails = (el) => {
        // el.preventDefault();
        // el.stopPropagation();

        const postType = el.target.getAttribute("data-post-type");
        const postID = Number(el.target.getAttribute("data-id"));
        
        getNextCategoryDetails(postType, postID);
    };

    /**
     * Returns all categories from the custom endpoint
     * @param el
     */
    const getAllCategories = (el) => {
        // el.preventDefault();
        // el.stopPropagation();

        if ( observerTarget  ) {
            lazyLoadObserver.unobserve(observerTarget);
        } else {
            lazyLoadObserver.unobserve(document.getElementsByClassName("js-team-load-more")[0]);
        }

        if ( Array.isArray(allTeamCategories) && allTeamCategories.length !== 0 )
        return getCurrentCategoryDetails(el);

        const teamPostRequestURL = `${document.location.origin}/wp-json/v2/taxonomy/team`;

        const postsRequest = new XMLHttpRequest();
        postsRequest.open("GET", teamPostRequestURL);
        postsRequest.send();
        postsRequest.onload = () => {
            if (postsRequest.status === 200) {
                allTeamCategories = JSON.parse(postsRequest.response);
                getCurrentCategoryDetails(el);
            }
        };
    };

    const lazyLoadObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                getAllCategories(entry);
                // eventListener();
                observerTarget = entry.target;
            }
        });
    });

    /**
     * Register EventListener for Load More button
     */
    const eventListener = () => {
        if (DOM.loadMore) {
            lazyLoadObserver.observe(document.getElementsByClassName("js-team-load-more")[0]);
            // DOM.loadMore.addEventListener("click", getAllCategories);
        }
    }

    const init = () => {
        cacheDOM();
        eventListener();
    };

    return {
        init
    };
})();

export default TeamPostRequest;
